module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/DurationShingleTable-38de61823227aafac397d400997d22c6.png";